import isObject from './is-object.js';
function isEmptyObject(value) {
    if (!value) {
        return true;
    }
    if (isObject(value)) {
        return Object.keys(value).length === 0;
    }
    return false;
}
export default isEmptyObject;
//# sourceMappingURL=is-empty-object.js.map